// Header.js
import React, { useState, useEffect } from 'react';
import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';

const Header = () => {
  const [isMobile, setIsMobile] = useState(false);

  // Listen for screen size change and update the state
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 600) {
        setIsMobile(true); // Set to mobile if screen size is less than 600px
      } else {
        setIsMobile(false); // Set to desktop for larger screens
      }
    };

    // Set initial screen size
    handleResize();

    // Add event listener for resizing
    window.addEventListener('resize', handleResize);

    // Clean up event listener
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? <HeaderMobile /> : <HeaderDesktop />;
};

export default Header;
